let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aJd4I")).then(() => parcelRequire('ixNSY'));